// src/utils/auth.js

const TOKEN_KEY = "jwtToken";
const REFRESH_TOKEN_KEY = "jwtRefreshToken";

export const getAuthToken = () => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    //console.log("✅ Retrieved token:", token);
    return token;
  } catch (err) {
    console.error("❌ Error getting auth token:", err);
    return null;
  }
};

export const getRefreshToken = () => {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch (err) {
    console.error("❌ Error getting refresh token:", err);
    return null;
  }
};

export const setAuthToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    //console.log("✅ Auth token set successfully.");
  } catch (err) {
    console.error("❌ Error setting auth token:", err);
  }
};

export const setRefreshToken = (token) => {
  try {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
    //console.log("✅ Refresh token set successfully.");
  } catch (err) {
    console.error("❌ Error setting refresh token:", err);
  }
};

export const clearAuthTokens = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    //console.log("✅ Auth and refresh tokens cleared.");
  } catch (err) {
    console.error("❌ Error clearing auth tokens:", err);
  }
};
